export const REGISTER_TASK = 'REFRESHER/REGISTER_TASK';
export const REGISTER_RUNNER = 'REFRESHER/REGISTER_RUNNER';
export const CLEAN_RUNNERS = 'REFRESHER/CLEAN_RUNNERS';
